import React, { useState } from "react";

export const useVisibility = (): [
  (items: string[]) => void,
  (item: string) => void,
  (item: string) => boolean,
  (item: string) => void
] => {
  const [visibleItems, setVisibleItems] = useState<string[]>([]);

  const toggleVisibility = (item: string) => {
    if (visibleItems.includes(item)) {
      visibleItems.splice(visibleItems.indexOf(item), 1);
    } else {
      visibleItems.push(item);
    }
    setVisibleItems([...visibleItems]);
  };

  const isVisible = (item: string) => {
    return visibleItems.includes(item);
  };

  const showItem = (item: string) => {
    if (!visibleItems.includes(item)) {
      visibleItems.push(item);
      setVisibleItems([...visibleItems]);
    }
  };

  const addVisibleItems = (items: string[]) => {
    setVisibleItems([...items]);
  };

  return [addVisibleItems, toggleVisibility, isVisible, showItem];
};
